import { css } from "@emotion/react";

export const secureText = css`
  max-width: 12.5rem;
  margin-bottom: 0.5rem;
`;
